var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTym(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 65,
    viewBox: "0 0 72 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.21 24.29L33.43 26.9L29.45 28.61L23.21 24.29Z",
    fill: "#900A15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4502 28.61H32.4002L33.7202 43.4L34.0202 43.45L33.7402 34.35L33.4302 26.9L29.4502 28.61Z",
    fill: "#CB0A29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.44 42.92L31.67 35.2L31.42 33.5C31.28 32.4 30.71 31.43 29.87 30.82L23.21 26.04L23.99 32.48L28.68 34.1C29.27 34.29 29.74 34.77 29.97 35.39L31.26 42.09L32.44 42.93V42.92Z",
    fill: "#E70012"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2597 42.08L29.9697 35.38C29.8497 34.74 29.2697 34.28 28.6797 34.09L23.9897 32.48L25.2697 33.39C26.8297 34.51 27.9997 36.2 28.5597 38.16L29.3997 40.62C29.4297 40.73 29.4997 40.83 29.5897 40.9L31.2597 42.08Z",
    fill: "#900A15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23.21L23.21 24.29L33.43 26.9L34.02 43.45L36 43.79L37.98 43.45L38.57 26.9L48.79 24.29L36 23.21Z",
    fill: "#E70012"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7898 24.29L38.5698 26.9L42.5498 28.61L48.7898 24.29Z",
    fill: "#900A15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.55 28.61H39.6L38.28 43.4L37.98 43.45L38.25 34.02L38.57 26.9L42.55 28.61Z",
    fill: "#CB0A29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5601 42.92L40.3301 35.2L40.5801 33.5C40.7201 32.4 41.2901 31.43 42.1301 30.82L48.7901 26.04L48.0101 32.48L43.3201 34.1C42.7301 34.29 42.2601 34.77 42.0301 35.39L40.7401 42.09L39.5601 42.93V42.92Z",
    fill: "#E70012"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7397 42.08L42.0297 35.38C42.1497 34.74 42.7297 34.28 43.3197 34.09L48.0097 32.48L46.7297 33.39C45.1697 34.51 43.9997 36.2 43.4397 38.16L42.5997 40.62C42.5697 40.73 42.4997 40.83 42.4097 40.9L40.7397 42.08Z",
    fill: "#900A15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTym);
export default __webpack_public_path__ + "static/media/tym.91a8fe37e13bc8aea3e8107bf7c5a351.svg";
export { ForwardRef as ReactComponent };